import { render, staticRenderFns } from "./suspended.vue?vue&type=template&id=150f950e&scoped=true"
import script from "./suspended.vue?vue&type=script&lang=js"
export * from "./suspended.vue?vue&type=script&lang=js"
import style0 from "./suspended.vue?vue&type=style&index=0&id=150f950e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f950e",
  null
  
)

export default component.exports